import {StyleSheet} from 'react-native';

const styles = StyleSheet.create({
  maxWidth327: {
    maxWidth: 327,
  },
});

export default styles;
